module.exports = __webpack_public_path__ + "cae2f8d7a76edd6c0179be5733140b30.png";